import GetSurveyUseCase from './use-cases/get-survey';
import SubmitSurveyUseCase from './use-cases/submit-survey';


const SurveyService = {
  async getSurvey(payload) {
    try {
      const surveyForm = await GetSurveyUseCase.execute(payload);

      return surveyForm;
    }
    catch (error) {
      throw error;
    }
  },

  async submitSurvey(payload) {
    try {
      await SubmitSurveyUseCase.execute(payload);
    }
    catch (error) {
      throw error;
    }
  }
};

export default SurveyService;
